export default __webpack_public_path__ + "static/media/es-tfg-img.66a0137d.webp";